// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"fcc3cdce","321":"aa4ddb11","374":"c04eefbc","842":"8df647c5"}[chunkId] + ".chunk.js";
};